var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.902143 1.40391C0.980265 1.15609 1.2184 0.975806 1.50004 0.975806H8.50004C8.78168 0.975806 9.01982 1.15609 9.09794 1.40391L5.00004 4.04772L0.902143 1.40391ZM0.125057 1.574C0.124987 1.57787 0.124982 1.58174 0.12504 1.58561V6.41935C0.12504 7.15425 0.740648 7.75 1.50004 7.75H8.50004C9.25943 7.75 9.87504 7.15425 9.87504 6.41935V1.58559M9.12504 2.25874V6.41935C9.12504 6.7534 8.84522 7.02419 8.50004 7.02419H1.50004C1.15486 7.02419 0.87504 6.7534 0.87504 6.41935V2.25874L4.79203 4.78582C4.91799 4.86709 5.08209 4.86709 5.20805 4.78582L9.12504 2.25874ZM9.87502 1.57401C9.87133 0.842169 9.25715 0.25 8.50004 0.25H1.50004C0.742939 0.25 0.128755 0.842161 0.125057 1.574",
    fill: "#5D6F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.0582ef9954fba6935000108b5c68138d.svg";
export { ForwardRef as ReactComponent };